<style scoped>
    .table-column-1 {
        width: 40%;
    }
</style>

<template>
    <table id="pending_table" class="table" data-name="Invited to Register" >
        <thead>
            <tr>
                <th v-for="field in fields" :key="field.key">{{ field.label }}</th>
            </tr>
        </thead>
        <tbody>
            <!-- empty table alert -->
            <tr v-if="pendingInvites.length == 0">
                <td :colspan="fields.length">
                    <div role="alert" aria-live="polite">
                        <div class="text-center my-2">
                            You don't have any pending invitations to connect
                        </div>
                    </div>
                </td>
            </tr>
            <!-- display data if present -->
            <tr v-for="item in pendingInvites">
                <td class="table-column-1">{{item.to_name}}</td>

                <td>{{ formatDate(item.invited_at) }}</td>
                <td>{{ formatDate(item.last_resent_at) }}</td>
                <td>
                    <button class="btn-orange-blue btn-xs" @click="resendInvite(item)"><small>Resend</small></button>
                </td>
                <td>
                    <a class="btn-orange-blue btn-sm" @click.prevent="deleteInvite(item)">Disconnect</a>
                    <a class="btn-x" @click.prevent="deleteInvite(item)"><i class="fa fa-times" aria-hidden="true"></i></a>
                </td>
            </tr>
        </tbody>
    </table>
</template>

<script>

    export default {
        components: {},
        props: {
            sortBy: {
                required: false,
                default: 'user-info',
                type: String
            },
            sortDesc: {
                required: false,
                default: false,
                type: Boolean
            }
        },
        data() {
            return {
                pendingInvites: [],
                fields: [
                    {
                        key: 'to_name',
                        label: 'User Information',
                        sortable: true,
                        thStyle: { width: '40%' }
                    },
                    {
                        key: 'invited_at',
                        label: 'Date First Invited',
                        sortable: true
                    },
                    {
                        key: 'last_resent_at',
                        label: 'Date of Last Invite',
                        sortable: true
                    },
                    {
                        key: 'resend-invite',
                        label: 'Resend Invitation',
                    },
                    {
                        key: 'disconnect',
                        label: 'Disconnect',
                        sortable: false
                    }
                ],
            }
        },
        methods: {
            updateData() {
                // TODO: just remove the item from the list instead of reloading 
                window.location.reload();
            },
            deleteInvite(invite) {
                if (confirm('Are you sure you want to delete from this invite?')) {
                    axios.delete('/api/invites/'+invite.id)
                        .then(response => {
                            this.updateData()
                        })
                        .catch(error => {
                            if (error.response.status == 403) {
                                alert(error.response.data.message)
                            }
                        });
                }
            },
            resendInvite(invite) {
                axios.get('/consultants/resend-invite/'+invite.id)
                    .then(response => {
                        this.updateData();
                    });
            },
            getPendingInvites() {
                axios.get('/api/consultants/pending-invites')
                    .then(response => {
                        this.pendingInvites = response.data.data;
                    })
                    .catch(error => {
                        console.log(error)
                    })
            },
            formatDate(dateString, format = 'MM/DD/YY') {
                if (moment(dateString).isValid()) {
                    return moment(dateString).utc().format(format)
                }
                return null
            }
        },
        created() {
            this.getPendingInvites();
        }
    
}
</script>